import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const AccessoriesList = () => {
  const page = 1;
  const itemsPerPage = 10;

  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [accessories, setAccessories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const jwtToken = localStorage.getItem("jwt_token");
  const [filterInput, setFilterInput] = useState("");

  const AccessoriesListData = async (page) => {
    fetch(`${process.env.REACT_APP_API_URL}/accessories-list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (response.ok) {
          setAccessories(data.data);
          setPageCount(Math.ceil(data.data.count / itemsPerPage));
          setLoading(false);
        }
        return Promise.reject(data.error);
      })
      .catch((error) => {
        toast.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      AccessoriesListData(currentPage);
    }, 500);
    return () => clearTimeout(getData);
  }, [filterInput]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
    AccessoriesListData(event.selected + 1);
  };

  return (
    <>
      {loading ? (
        <div className="text-center" style={{ width: "100%" }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="row my-2">
            <div className="col">Accessories</div>
            <div className="col">
              <span className="mr-2">Search and filters:</span>
              <input
                type="text"
                placeholder="E.g. Filter for “Name, Email & Customer ID"
                value={filterInput}
                onChange={(e) => {
                  setFilterInput(e.target.value);
                }}
              />
            </div>
            <div className="col d-flex justify-content-end">
              <Link to="/accessories/list-accessories">
                <button className="btn bg_color m-2" type="text">
                  Add Accessories
                </button>
              </Link>
              <Link to="/accessories/add-accessories">
                <button className="btn bg_color m-2" type="text">
                  Buy Accessories
                </button>
              </Link>
              <Link to="/accessories/sell-accessories">
                <button className="btn bg_color m-2" type="text">
                  Sell Accessories
                </button>
              </Link>
            </div>
          </div>

          <table className="table">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Item Name</th>
                <th scope="col">Quantity</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {accessories.map((item, i) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{item.accessoriesid}</th>
                    <td>{item.name}</td>
                    <td>{item.quantity}</td>
                    <td>
                      <i
                        type="button"
                        className="nav-icon fas fa-eye btn btn-lg bg_color"
                        onClick={() => {
                          history.push({
                            pathname: `/accessories/transaction-accessories`,
                            search: `?id=${item.id}`,
                          });
                        }}
                      ></i>
                    </td>
                    <td>
                      <i
                        type="button"
                        className="nav-icon fas fa-edit btn btn-lg bg_color"
                        onClick={() => {
                          history.push({
                            pathname: `/accessories/list-accessories`,
                            search: `?id=${item.id}`,
                            state: { rowData: item },
                          });
                        }}
                      ></i>
                    </td>
                  </tr>
                );
              })}
              <tr hidden={accessories.length !== 0}>
                <td colSpan="5" className="text-center">
                  Data Not Found
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}

      <ReactPaginate
        nextLabel="Next"
        onPageChange={handlePageClick}
        pageRangeDisplayed={10}
        pageCount={pageCount}
        previousLabel="Previous"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link bg_color"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />
    </>
  );
};

export default AccessoriesList;
